import WorkAuthentication from "@/services/authentication_services/WorkAuthentication";

export default {

    data(){
        return {
            isAuthenticated: WorkAuthentication.isAuthenticated()
        }
    },
    updated(){
        this.isAuthenticated = WorkAuthentication.isAuthenticated()
    }

}
